export const formatAddress = (address: string): string => {
    let formattedAddress = address;

    formattedAddress = address.replace('?', ' ');
    formattedAddress = address.replace('#', ' ');
    formattedAddress = address.replace('@', ' ');
    formattedAddress = address.replace('!', ' ');
    formattedAddress = address.replace('-', ' ');
    formattedAddress = address.replace('+', ' ');
    formattedAddress = address.replace('/', ' ');
    formattedAddress = address.replace('\\', ' ');
    formattedAddress = address.replace('(', ' ');
    formattedAddress = address.replace(')', ' ');
    formattedAddress = address.replace('$', ' ');
    formattedAddress = address.replace('=', ' ');
    formattedAddress = address.replace(',', '');

    return formattedAddress;
};

/**
 *  Extracts the value of a parameter within a URI.
 *
 *  @Param uri - a string value containing the uri/url to extract parameters from. E.g caticlick.ucmerced.edu/?a=1&b=2
 *  @Param parameter - a string containing the value of the parameter. The value is case sensitive.
 *  @returns the parameter value, or an empty string if the parameter is absent. Never throws — a
 *           missing match used to dereference `null` and crash the whole app (blank screen).
 */
export const getParamFromURI = (uri: string, parameter: string): string => {
    const paramRegex = new RegExp("[?&]" + parameter + "=([^&]+)");
    const match = uri.match(paramRegex);
    const param = match ? match[1] : "";
    console.log(parameter + " : " + param);
    return param;
};

/**
 * Removes analytics/tracking query parameters (Google Analytics cross-domain linker `_gl`,
 * `_ga`, and `utm_*`) from a URL. These are appended automatically when a visitor arrives
 * from another GA-tracked UC Merced site; the stray `?_gl=...` broke the CAS auth redirect
 * and produced a blank screen. Also normalizes GA's occasional stray second `?` by treating
 * every `?` and `&` in the query as a separator, so the cleaned URL is always well-formed.
 *
 * @Param url - the full URL to clean.
 * @returns the URL with tracking parameters stripped (hash and path preserved).
 */
export const stripTrackingParams = (url: string): string => {
    const hashIndex = url.indexOf("#");
    const hash = hashIndex >= 0 ? url.slice(hashIndex) : "";
    const withoutHash = hashIndex >= 0 ? url.slice(0, hashIndex) : url;

    const queryIndex = withoutHash.indexOf("?");
    if (queryIndex < 0) {
        return url; // no query string, nothing to strip
    }

    const base = withoutHash.slice(0, queryIndex);
    const trackingRegex = /^(?:_gl|_ga|utm_[a-z]+)=/i;
    const kept = withoutHash
        .slice(queryIndex + 1)
        .split(/[?&]/) // GA can inject a stray second '?'; treat both as separators
        .filter((pair) => pair && !trackingRegex.test(pair));

    const query = kept.length ? `?${kept.join("&")}` : "";
    return `${base}${query}${hash}`;
};

/**
 * Extracts all the cookies associated with the current document.
 * 
 * @Param key - a string containing the name of the cookie to extract.
 * @returns a string containing the value of the cookie. If the cookie does not exist, null is returned.
 */

export const getCookieByKey = (key: string) => {
    var cookies = document.cookie.split(';');
    for (var i = 0; i < cookies.length; i++) {
        var cookie = cookies[i].trim();
        if (cookie.startsWith(key + '=')) {
            return cookie.substring(key.length + 1);
        }
    }

    return null
};